import * as React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import Order from "pages/Order/Loadable";

const generalEnrollmentRoutes = createBrowserRouter([
  {
    path: "/",
    element: <Order />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);

export const router = generalEnrollmentRoutes;
